/** The names of the selections every board has, spelled once here for the
 *  definition schema's checks and for every module that reads or writes one. */
export const TIME_RANGE_SELECTION = "time_range";

export const FOCUS_SELECTION = "focus";

export const BRUSH_SELECTION = "brush";

export const CONTROL_VALUES_SELECTION = "control_values";

/** What a person calls the `focus` and `brush` selections, which nobody
 *  named: what was picked on the board, and a range dragged across a chart.
 *  A selection an author declared is called by its name. */
export function selectionLabel(selection: string): string {
  if (selection === FOCUS_SELECTION) {
    return "Picked on the board";
  }
  if (selection === BRUSH_SELECTION) {
    return "Range dragged across a chart";
  }
  return selection;
}

/** A selection as a sentence names it: "what is picked", "the range
 *  dragged across a chart", or `the selection “region”` for a selection an
 *  author declared. */
export function selectionPhrase(selection: string): string {
  if (selection === FOCUS_SELECTION) {
    return "what is picked";
  }
  if (selection === BRUSH_SELECTION) {
    return "the range dragged across a chart";
  }
  return `the selection “${selection}”`;
}
